<template>
  <fieldset>
    <hr
      v-if="resultHtml && hasTopLine"
      class="mb-10"
    >
    <div
      v-dompurify-html="resultHtml"
      class="result-message text-center"
      :class="messageClass"
    />
    <hr
      v-if="resultHtml && hasBottomLine"
      class="mb-10"
    >
  </fieldset>
</template>

<script setup lang="ts">
defineProps({
  resultHtml: {
    type: String,
    required: true,
  },
  messageClass: {
    type: String,
    default: '',
  },
  hasTopLine: {
    type: Boolean,
    default: true,
  },
  hasBottomLine: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss">
.result-message {
  white-space: pre-wrap;
  h3 {
    font-size: 16px !important;
    color: #f00;
    margin-bottom: 10px;
  }
  .span {
    font-size: 14px !important;
  }
  .success {
    color: green;
  }
  .error {
    color: #f00 !important;
  }
  .service-content {
    padding-bottom: 10px;
    p {
      font-size: 16px;
    }
  }
}
</style>
